const n = {
  "cdr-link": "cdr-link_15-4-1",
  "cdr-link--standalone": "cdr-link--standalone_15-4-1",
  "cdr-link--inherit-color": "cdr-link--inherit-color_15-4-1"
};
export {
  n as default
};
